var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedVv0)",
    d: "m13.522 15.57l-.172.283a.6.6 0 0 1-.085.094a.03.03 0 0 1-.04 0a.3.3 0 0 1-.076-.077l-.926-1.543l3.386-5.597a.6.6 0 0 0 .068-.206a.3.3 0 0 0-.043-.201c-.064-.103-.201-.167-.321-.18H5.957a1.5 1.5 0 0 0-.544.077c-.021.009-.026 0-.013-.013q.32-.513.647-1.007c.073-.103.155-.231.245-.326c.224-.239.53-.385.857-.411a1 1 0 0 1 .257-.034h9.48a1.33 1.33 0 0 1 1.029.484q.038.044.05.081q.017.046.044.086a1 1 0 0 1 .094.193a1.08 1.08 0 0 1-.043.771l-.145.253zm-1.419-.827l.754 1.26c.065.111.159.21.283.244c.249.065.416-.128.523-.308l4.629-7.667a1.2 1.2 0 0 0 .15-.42q.005-.02.017 0l.068.12c.223.385.455.788.643 1.157a1.22 1.22 0 0 1-.06 1.153l-4.74 7.894a1.34 1.34 0 0 1-1.084.681a1.23 1.23 0 0 1-.969-.407a1 1 0 0 1-.12-.171l-.008-.009l-4.552-7.504l-.021-.043c-.043-.069-.09-.141-.112-.223c-.004-.03.009-.043.035-.051h.017l.064-.013h1.87l.004-.001h.004c.866 1.44 1.736 2.872 2.606 4.308m3.249-6.313a.35.35 0 0 0-.155-.034h-2.7q-3.272.01-6.544.008a1.26 1.26 0 0 0-.9.343a1 1 0 0 0-.129.176l-.012.026l-.039.043a.4.4 0 0 0-.047.072a1.22 1.22 0 0 0 .068 1.145l.206.343l4.642 7.628a1.41 1.41 0 0 0 .977.664l.094.005l.09.008h1.329l-4.136-6.754l-.802-1.329a.8.8 0 0 1-.085-.205c-.06-.189.021-.369.214-.437l.043-.013h.013c.013 0 .021 0 .03-.009a.3.3 0 0 1 .085-.013l6.802-.004l.93-1.543q.03-.05.03-.107z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedVv0",
    x1: 17.224,
    x2: 7.479,
    y1: 8.524,
    y2: 15.043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76D7FF"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVv);
export default __webpack_public_path__ + "static/media/vv.1698fef016c0b5e6af66f9fa5d023caf.svg";
export { ForwardRef as ReactComponent };